import { render, staticRenderFns } from "./PgAgent.vue?vue&type=template&id=4222b00f&scoped=true"
import script from "./PgAgent.vue?vue&type=script&lang=js"
export * from "./PgAgent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4222b00f",
  null
  
)

export default component.exports